/* global angular swal moment, _ */
import './style.less';

export default function($log, $stateParams, ResolveClass) {
  'ngInject';

  const vm = this;

  vm.applicationSettings = feature => {
    return ResolveClass.applicationSettings(feature);
  };

  vm.stateParams = $stateParams;

  $log.debug('Users Learning Activated');
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/learning/nav/index.js